import React from 'react';
import PropTypes from 'prop-types';
import { isAbsent } from 'helpers/verify';
import { CitcatLinks } from 'components/CmsPage/modules/CitcatLinks/CitcatLinks';
import { LocationSelector } from 'components/CmsPage/modules/LocationSelector/LocationSelector';
import { PressTestimonials } from 'components/PressTestimonials/PressTestimonials';
import { SearchBoxContainer } from 'features/Search/SearchBox/SearchBoxContainer';
import { SEARCHBOX_THEMES } from 'features/Search/SearchBox/SearchBox.constants';
import { VenueSupplyContainer } from 'components/CmsPage/modules/VenueSupply/VenueSupplyContainer';

const STATIC_MODULE_RENDERER_BY_NAME = {
  citcat_links_light: () => <CitcatLinks backgroundColor="light" />,
  citcat_links_white: () => <CitcatLinks backgroundColor="white" />,
  location_selector: () => <LocationSelector />,
  press_testimonials: () => <PressTestimonials />,
  search_box_on_home_hero: () => (
    <SearchBoxContainer
      optimizelyEventTrackingName="Search on Home (hero) click"
      theme={SEARCHBOX_THEMES.onDarkCentered}
    />
  ),
  venue_supply: () => <VenueSupplyContainer />,
};

export const StaticModule = ({ moduleName, moduleRendererByName = STATIC_MODULE_RENDERER_BY_NAME }) => {
  const moduleRenderer = moduleRendererByName[moduleName];

  if (isAbsent(moduleRenderer)) {
    // eslint-disable-next-line no-console
    console.error(`Module [${moduleName}] is not registered`);

    return null;
  }

  return moduleRenderer();
};

StaticModule.propTypes = {
  moduleName: PropTypes.string.isRequired,
};
